
import Main from "./classes/display/Main";
import "./index.scss";

window.addEventListener('load', (() => new Main()), false);
